/* eslint-disable @typescript-eslint/no-explicit-any */
import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  MobileAppBrandingPayload,
  MobileAppDataModel
} from './MobileAppManagementAPI.model'
import { HTTPInstanceFastApi } from '@/lib/http/http-instance-fastapi'

class MobileAppManagementAPI {
  static setLogoImage = (formData: any): Promise<any> =>
    HTTPInstanceWithPrefix.post('/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response.data)

  static getLogoImage = (): Promise<any> =>
    HTTPInstanceWithPrefix.get('/logo', {}).then(response => response.data)

  static setBackgroundImage = (formData: any): Promise<any> =>
    HTTPInstanceWithPrefix.post('/background', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response.data)

  static getBackgroundImage = (): Promise<any> =>
    HTTPInstanceWithPrefix.get('/background', {}).then(
      response => response.data
    )

  static getMenuTypeImages = (menuTypeId: string): Promise<any> =>
    HTTPInstanceWithPrefix.get(`/menu-types/${menuTypeId}/images`).then(
      response => response.data
    )

  static getMobileAppData = (): Promise<MobileAppDataModel> =>
    HTTPInstanceWithPrefix.get('/mobile-app').then(response => response.data)

  static postMobileAppData = (
    payload: MobileAppBrandingPayload
  ): Promise<MobileAppDataModel> =>
    HTTPInstanceWithPrefix.post('/mobile-app', payload).then(
      response => response.data
    )

  static extractColorsSchemeFromImage = (file: File) => {
    const formData = new FormData()
    formData.append('image', file)
    return HTTPInstanceFastApi.post(`/api/colors`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response.data)
  }
}

export default MobileAppManagementAPI
